/* This is the default file provided by katal */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */

import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import { KatalMonitoringDriver, KatalMonitoringDriverOptions } from '@amzn/katal-monitoring-aws-driver';
import MetricDimensionNames from 'src/constants/metricConstants';

const metricsConsoleErrorHandler = (err: Error) => console.error(err);

/**
 * Builds Katal based metrics driver based on the environment the app is running.
 */
const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
  if (process.env.NODE_ENV === 'test') {
    const metricsDriver = new KatalMetricsDriverArrayCollector();
    //  Attach to global window object so tests can see it
    (window as any).metricsDriver = metricsDriver;
    return metricsDriver;
  }
  const monitoringConfig: KatalMonitoringDriverOptions = {
    url: 'https://l28uobw2i6.execute-api.us-west-2.amazonaws.com/prod/v1/monitoring',
  };
  return new KatalMonitoringDriver(monitoringConfig);
};

/**
 * Builds Katal based metrics publisher for publishing frontend metrics.
 * @param program Optional parameter to support program based metrics.
 */
export const makePublisher = (program?: string): KatalMetrics.Publisher => {
  const metricsDriver = makeMetricsDriver();
  const serviceName = process.env.NODE_ENV === 'test' ? 'GSCategoryManagement' : 'GSCategoryManagement.prod';
  let initialMetricsContext = new KatalMetrics.Context.Builder()
    .withSite('GSCategoryManagementWebsite')
    .withServiceName(serviceName);

  if (program) {
    initialMetricsContext = initialMetricsContext.withCloudWatchDimensions([
      new KatalMetrics.Metric.String(MetricDimensionNames.PROGRAM_DIMENSION, program),
    ]);
  }
  return new KatalMetrics.Publisher(metricsDriver, metricsConsoleErrorHandler, initialMetricsContext.build());
};

export const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;
